import service from '@/utils/request';
export var getTableColumn = function getTableColumn(path) {
  return service({
    url: "/xcpGameData/formConfig",
    method: 'post',
    data: {
      "menu_url": path
    }
  });
};